<template>
    <header id="header">
        <nav class="navbar navbar-expand-lg p-0 p-lg-0 flex-grow-1">
            <div class="container">
                <div class="d-flex flex-wrap flex-lg-nowrap justify-content-between align-items-center w-100">
                    <span href="javascript:;" class="sidebar-opener"><span></span></span>
                    <div class="brand mr-15 mr-xl-0 flex-shrink-0 col-xl-3">
                        <router-link onclick="closeMenu()" :to="{ name: 'allMatches' }">
                                     <img class="lazyload" :src="$vuePublicPath('/images/logo.svg')" width="183" height="26" alt="Planet Cricket" />
                        </router-link>
                    </div>
                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-expanded="false">
                        <span>Menu</span>
                    </button>
                    <div class="collapse navbar-collapse justify-content-end col-xl-9 p-lg-0 pl-lg-10" id="navbarSupportedContent">
                        <div class="navbar-collapse-holder">
                            <ul class="navbar-nav">
                                <li class="nav-item" :class="{ active: $route.name == 'allMatches', current: $route.path.includes('/match/') }">
                            <router-link onclick="closeMenu()" :to="{ name: 'allMatches' }" class="nav-link"><span>Matches</span></router-link>
                            </li>
                            <li class="nav-item" :class="{ active: $route.name == 'liveMatches' }">
                        <router-link onclick="closeMenu()" :to="{ name: 'liveMatches' }" class="nav-link">
                                     <span>In-play ({{ liveCount }})</span>
                        </router-link>
                        </li>
                        <li class="nav-item" :class="{ active: $route.name == 'myMatches' }">
                    <router-link onclick="closeMenu()" :to="{ name: 'myMatches' }" class="nav-link">
                                 <span>My Games ({{ $store.getters.favouriteMatches.length }})</span>
                    </router-link>
                    </li>
                    <li class="nav-item" :class="{ active: $route.name == 'newsList' || $route.name == 'tournamentNews' }">
                <router-link onclick="closeMenu()" :to="{ name: 'newsList' }" class="nav-link"><span>News</span></router-link>
                </li>
                <li class="nav-item" :class="{ active: $route.name == 'highlights' }">
            <router-link onclick="closeMenu()" :to="{ name: 'highlights' }" class="nav-link"><span>Videos</span></router-link>
            </li>
        </ul>
        <ul class="right-menu">
            <li class="position-relative" v-click-outside="closeCalendar" v-if="$route.name == 'allMatches'">
                <span class="calendar-opener" @click.prevent="showCalendar = ! showCalendar">
                    <i class="ico-calendar"></i>
                </span>
                <div class="calendar-wrap disable-select" v-if="showCalendar">
                    <span class="close-calender" @click="closeCalendar"><i class="ico-close"></i></span>
                    <datepicker :inline="true" v-model="date" @input="updateDate()"></datepicker>
                </div>
            </li>
            <li>
                <span href="javascript:;" class="search-form-opener"><i class="ico-search"></i></span>
                <div class="search-form-wrap">
                    <form class="search-form" v-on:submit.prevent="search()">
                        <div class="search-input-wrap">
                            <input
                                id="topSearchBar"
                                class="form-control"
                                v-model="searchInput"
                                type="search"
                                placeholder="Search"
                                autocomplete="off"
                                />
                            <button class="btn-search" aria-label="search"><i class="ico-search"></i></button>
                        </div>
                    </form>
                </div>
            </li>
            <li class="dropdown header-dropdown">
                <span class="dropdown-toggle" data-toggle="dropdown" href="javascript:;"
                   ><i class="ico-grid"></i
                    ></span>
                <div class="dropdown-menu">
                    <!--<router-link class="dropdown-item" :to="{ name: 'aboutUs' }"> About Us </router-link>-->
                    <!--<router-link class="dropdown-item" :to="{ name: 'faq' }"> FAQ </router-link>-->
                    <router-link onclick="closeMenu()" class="dropdown-item" :to="{ name: 'privacyPolicy' }"> Privacy Policy </router-link>
                    <router-link onclick="closeMenu()" class="dropdown-item" :to="{ name: 'termsConditions' }"> Terms & Conditions </router-link>
                </div>
            </li>
            <li class="text-center">
                <span class="theme-swhicher-btn" @click="switchTheme()" onclick="closeMenu()">
                    <i class="ico-sun light ico"></i>
                    <i class="ico-moon dark ico"></i>
                </span>
            </li>
        </ul>
    </div>
</div>
</div>
</div>
</nav>
</header>
</template>

<script>
    import allMatches from '../matches/AllMatches.vue'

    export default {
        name: 'Header',

        components: {
            'datepicker': () => import('vuejs-datepicker')
        },

        data() {
            return {
                date: new Date(),
                liveCount: 0,
                searchInput: '',
                showCalendar: false,
            }
        },

        jsonld() {
            return {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name" : 'Planet Cricket',
                "url": "https://www.planetcricket.com",
                "logo": process.env.BASE_URL +"public/images/logo.svg"
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.getLiveCount()
            }
        },
        mounted() {
            this.$root.$on('date', (text) => { // here you need to use the arrow function
                this.date = text;
            }),
                    this.getLiveCount()
            if (isBrowser)
                setInterval(() => this.getLiveCount(), 1000 * 60)
        },

        methods: {
            getLiveCount() {
                clickedElement = null;
                return this.$axios
                        .get(this.$LIVE_COUNT_API, {params: {ttl: 0}})
                        .then(response => {
                            this.liveCount = response.data.result.count || 0
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },

            switchTheme() {
                if (this.$store.getters.theme == 'dark') {
                    this.$store.commit('switchTheme', 'light')
                    document.querySelector('body').classList.add('light-theme-active')
                } else {
                    this.$store.commit('switchTheme', 'dark')
                    document.querySelector('body').classList.remove('light-theme-active')
                }
            },
            search() {
                if (this.searchInput) {
                    if (isBrowser) {
                        window.closeMenu();
                    }
                    this.$router.push({name: 'search', query: {search: this.searchInput}}).catch(() => {
                    })
                }
            },
            closeCalendar() {
                this.showCalendar = false
            },
            updateDate() {
                this.date = new Date(this.date).toISOString().slice(0, 10);
                this.$router.push({name: 'allMatches', params: {date: this.date}})

                this.closeCalendar()
                if (isBrowser)
                    window.closeMenu()
            },
        }
    }
</script>
